/** Normalizes collection names, removes case-insensitive duplicates, and preserves order. */
export function normalizeCollectionOptions(values = []) {
  const seen = new Set();
  return values
    .map((value) => String(value || '').trim())
    .filter(Boolean)
    .filter((value) => {
      const key = value.toLowerCase();
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    })
    .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));
}

/** Checks whether a collection name already exists without case or whitespace differences. */
export function includesCollectionName(options = [], value = '') {
  const key = String(value || '').trim().toLowerCase();
  return Boolean(key) && options.some((option) => String(option || '').trim().toLowerCase() === key);
}

/**
 * Performs the same collection name operation.
 *
 * @param {string} left - left value.
 * @param {string} right - right value.
 * @returns {*} The derived operation result.
 */
function sameCollectionName(left = '', right = '') {
  return String(left || '').trim().toLowerCase() === String(right || '').trim().toLowerCase();
}

/** Chooses existing/create mode from available collections and the current value. */
export function resolveCollectionMode({ options = [], value = '', defaultValue = '' } = {}) {
  if (!options.length) return 'new';
  const trimmedValue = String(value || '').trim();
  if (!trimmedValue || sameCollectionName(trimmedValue, defaultValue)) return 'existing';
  return includesCollectionName(options, trimmedValue) ? 'existing' : 'new';
}
